import React from 'react'
import Image from 'gatsby-image'
import useProductsImages from '../../hooks/useProductsImage'

export const PureBenefitImage = ({ data, classes }) => {
  const alt =
    'Produtos da Natura: Ekos Castanha (marcado com o número 1), Tododia Flor de Lis (marcado com o número 2), Essencial Supreme (marcado com o número 3) e Lumina Máscara (marcado com o número 4)'

  return (
    <Image
      className={classes}
      imgStyle={{ objectFit: 'contain' }}
      alt={alt}
      data-gtm-category="landing_ganhos_como_consultora"
      data-gtm-label={alt}
      data-gtm-main-action="ab_test"
      draggable={false}
      fluid={data && data.childImageSharp.fluid}
    />
  )
}

const ProductsImage = ({ lang, classes, tabActive, isEloThemeActive }) => {
  let index = lang
  if (isEloThemeActive){
    index = tabActive === 0 ? `${lang}` : `${lang}1`
  }

  const data = useProductsImages()
  return <PureBenefitImage data={data[index]} classes={classes} />
}

export default ProductsImage
